import moment from 'moment';

import { dateFormat } from '../../../../../contrib/utils';

import { IAdminEvent } from '../../../../../store/admin/events/store';

export const currentDate = moment();

export interface IOverviewGroups {
  pastEvents: IAdminEvent[];
  futureEvents: IAdminEvent[];
  currentEvents: IAdminEvent[];
}

export const getOverviewGroups = (events: IAdminEvent[]): IOverviewGroups => {
  const overviewGroups: IOverviewGroups = {
    currentEvents: [],
    futureEvents: [],
    pastEvents: []
  };
  events.forEach((event: IAdminEvent) => {
    const eventStartDate = moment(event.start, dateFormat);
    const eventEndDate = moment(event.end, dateFormat);
    if (currentDate.isBetween(eventStartDate, eventEndDate)) {
      overviewGroups.currentEvents.push(event);
    } else if (eventStartDate.isBefore(currentDate)) {
      overviewGroups.pastEvents.push(event);
    } else {
      overviewGroups.futureEvents.push(event);
    }
  });
  return overviewGroups;
};
